/* eslint-disable */
import axios from 'axios';

import {
	
} from './types'


export default {

    state : {
        _users : [],
        roles : [],
    },

   
    getters : {

        getPrefix(state) {
            let u = state._users;
            return ((u.length>0)&&(u[0].company != undefined)) ? (u[0].company+'_eventMessage') : 'wtf!';
        },
         
        allUsers(state) {
            return state._users;
        },

        getUserById: (state) => (id) => {
            return state._users.find(user => user.id === id)
        },

        getUsersByPosition : (state) => (position) => {
            return state._users.find(user => user.position === position)
        },

        getRoles(state) {
            return state.roles;
        },

        getRoleById: (state) => (id) => {
            return state.roles.find(role => role.id === id)
        },

    },

    mutations: {

        retrieveUsers(state, data) {
            state._users = data;
        },

        setRoles(state, data) {
            state.roles = data;
        }, 

        saveUser(state, data) {
            const index =  state._users.findIndex(item => item.id === data.id);
            if (index == -1) state._users.push(data);
            else state._users.splice(index, 1, data);
        }
        
    },

    actions : {

        saveUser({dispatch, commit, rootState, rootGetters}, data) {
            
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.post('/users/save', data)
                .then(response => {              
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'saveUser', 'content' : response.data});      
                    // rootState.ds.event.emit('saveUser', response.data);
                    resolve(response.data);           
                })
                .catch(error => {
                    reject(error);
                });
            });

        },

        retrieveUsers({dispatch, commit, rootState, rootGetters}) {
            
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.get('/users')
                .then(response => {
                    
                    if (!response) return;

                    commit('retrieveUsers', response.data['users']);
                    commit('setMyCompany', response.data['company']);


//=========================  Подписываемся на событие обновления ============================                    
                    if (rootState.ds != undefined) {
                        if (!rootState.ds.hasListeners('error')) rootState.ds.on('error', (error)=>{}); // подписываемся на событие ошибки ds, чтобы они не валились в консоль
                        rootState.ds.event.unsubscribe(rootGetters.getPrefix); // отписываемся от события (чтобы не было дубликатов)

                        rootState.ds.event.subscribe(rootGetters.getPrefix+"_dispatch", (data)=>{
                            console.log(data);
                            dispatch(data.event, data.content);
                        });

                        rootState.ds.event.subscribe(rootGetters.getPrefix, (data)=>{
                            console.log(data);
                            commit(data.event, data.content);
                        });

                    }
//===========================================================================================                        

                    resolve(response.data);           
                })
                .catch(error => {
                    if (error) {
                        console.log(error)
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                        } else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка 
                                dispatch('retrieveUsers');
                            }, t);
                            reject(error.response.status);
                        }
                    }   
                });
            });
        },

        retrieveRoles({dispatch, commit, rootState}) {
            
            return new Promise((resolve, reject) => {
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.get('/roles')
                .then(response => {
                    commit('setRoles', response.data);
                    resolve(response.data);           
                })
                .catch(error => {
                    let t = 2500;
                    if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                    setTimeout(()=>{        // повторная загрузка 
                        dispatch('retrieveRoles');
                    }, t);

                    reject(error);
                    
                });
            });
            
        },

    }

}